import type { Raw } from 'vue';
import type { ExtendedRulesDeclarations, ReglePartialRuleTree, RegleRoot } from '@regle/core';
import type { RegleFormInput } from '@/types/form/regle-form-input';

type UseRegleCompat<
    TForm extends object,
    TRules extends ReglePartialRuleTree<TForm, Partial<ExtendedRulesDeclarations>>
> = (
    form: RegleFormInput<TForm>,
    rules: MaybeRef<TRules>,
    options: { autoDirty: boolean }
) => { r$: Raw<RegleRoot<TForm, TRules>> };

// TS inference limitation at ReglePartialRuleTree:
// Unwrap<TForm> expands the type and breaks RegleRoot compatibility.
// Based on example from https://github.com/victorgarciaesgi/regle/issues/140
export function useRegleCompat<
    TForm extends object,
    TRules extends ReglePartialRuleTree<TForm, Partial<ExtendedRulesDeclarations>>
>(form: RegleFormInput<TForm>, rules: MaybeRef<TRules>) {
    const regle = useRegle as unknown as UseRegleCompat<TForm, TRules>;

    return regle(form, rules, { autoDirty: false });
}
